import React, { Component } from 'react'

import { keys, isObject } from 'lodash'

import { Modal, Button, Form, Input, Slider } from 'antd'

const formLayout = {
	labelCol: { span: 24 },
	wrapperCol: {
		span: 24,
	},
}

export const ScenarioEditionModal = (props: any) => {
	const [form] = Form.useForm()

	const handleFormSubmit = () => {
		console.log('handleFormSubmit')
		form.validateFields()
			.then((values) => {
				console.log('validated', values)
				props.onSave(values)
				props.onHide()
			})
			.catch((errorInfo) => {
				console.log('error', errorInfo)
			})
	}

	const footer = (
		<div style={{ display: 'flex' }}>
			{props.onDelete && (
				<Button
					onClick={() => {
						props.onDelete(props)
					}}
					danger={true}
					style={{ marginRight: 'auto' }}
				>
					Delete
				</Button>
			)}
			<Button
				onClick={() => {
					props.onHide()
				}}
				style={{ marginRight: 'auto' }}
			>
				Cancel
			</Button>
			<Button onClick={handleFormSubmit} type="primary">
				Save
			</Button>
		</div>
	)

	return (
		<Modal
			open={true}
			title={props.id ? 'Scenario edition' : 'Create a new scenario'}
			okButtonProps={{ style: { display: 'none' } }}
			onCancel={props.onHide}
			cancelText="Close"
			footer={footer}
		>
			<Form
				{...formLayout}
				form={form}
				onFinish={(values) => {
					props.onChange(props.id, values)
					props.onHide()
				}}
				initialValues={props.values}
			>
				<Form.Item
					name="name"
					label="Name"
					rules={[{ max: 35, message: 'Please choose a shorter name (35 characters max)' }]}
				>
					<Input></Input>
				</Form.Item>
				<Form.Item name="description" label="Description">
					<Input.TextArea rows={5}></Input.TextArea>
				</Form.Item>
				<Form.Item name="impacts" label="Impacts description">
					<Input.TextArea rows={7}></Input.TextArea>
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default ScenarioEditionModal
